import { SalesOrderActivity } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import queryClient from '@/lib/queryClient';

/**
 * 1340. 受注案件アクティビティ一覧
 * [GET] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/sales_order_activities
 */
type Props = {
  identifier: string;
  team_id: number;
  id: number;
};

const salesOrderActivities = (props: Props): Promise<SalesOrderActivity[]> => {
  return axios.get(`/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.id}/sales_order_activities`);
};

export const useSalesOrderActivities = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => salesOrderActivities(props)
  });
};

export const useSalesOrderActivitiesInvalidate = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: queryKey(props) });
  };

  return { invalidate };
}

const queryKey = (props: Props) => {
  return ['workspaces', props.identifier, 'teams', props.team_id, 'sales_orders', props.id, 'sales_order_activities'];
};
